import { motion } from "motion/react";

interface ControlsProps {
  isFavorite: boolean;
  onToggleFavorite: () => void;
  onChangeChannel: () => void;
  onToggleInfo: () => void;
  visible: boolean;
}

export default function Controls({
  isFavorite,
  onToggleFavorite,
  onChangeChannel,
  onToggleInfo,
  visible,
}: ControlsProps) {
  return (
    <motion.div
      className={`pointer-events-none transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
      data-ui-zone
    >
      <div className="acg-frame flex items-center justify-center gap-6 sm:gap-10 px-5 py-3 bg-white/80 pointer-events-auto w-max mx-auto">
        <button
          onClick={onToggleFavorite}
          className={`font-display text-2xl sm:text-3xl transition-colors ${
            isFavorite ? "text-signal" : "text-phosphor hover:text-signal"
          }`}
          aria-label={isFavorite ? "取消收藏" : "收藏"}
        >
          {isFavorite ? "♥" : "♡"}
        </button>

        <button onClick={onChangeChannel} className="group" aria-label="换台">
          <div className="acg-primary-button font-display font-bold text-sm sm:text-base tracking-[.14em] px-7 py-3 transition-colors">
            换台 · SPACE
          </div>
        </button>

        <button
          onClick={onToggleInfo}
          className="font-display text-2xl sm:text-3xl text-phosphor hover:text-signal transition-colors"
          aria-label="信息"
        >
          ✦
        </button>
      </div>
    </motion.div>
  );
}
